import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Modal from "../../../UIElements/Modal";
import * as actionCreator from "../../store/actions";
import { directDeepLink } from "@src/common/deepLinks";

import PaymentOptionsScreen from "./components/PaymentOptionsScreen";

const CheckoutOptionsBottomSheet = () => {
  const dispatch = useDispatch();
  const [isPaymentOptionsScreenVisible, setIsPaymentOptionsScreenVisible] =
    useState(false);
  const { t } = useTranslation();
  const checkoutOptionsList = [
    "Who secures your purchase, processes your payment, and stores any payment information",
    "Who provides customer support for the purchase",
    "Which forms of payment you can use",
    "Which benefits are available with your purchase",
  ];

  //REDUX STATES
  const showCheckoutOptionsBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showCheckoutOptionsBottomSheet
  );

  const handleLearnMoreClick = () => {
    const newDeepLink = {};
    newDeepLink.paramOne =
      "https://support.google.com/googleplay/answer/11174377";

    directDeepLink({}, "UTIL_WEBVIEW", false)(newDeepLink);
  };

  const renderCheckoutOptionsScreen = () => {
    return (
      <div className="CheckoutOptionsBottomSheet_container">
        <div>
          <p>
            {t(
              "components.bottomSheets.components.checkoutOptionsBottomSheet.checkoutOptionsPrimaryText",
              "You now have more options at checkout, due to recent regulatory changes in India. Your choice will determine:"
            )}
          </p>
          <ul>
            {checkoutOptionsList &&
              checkoutOptionsList.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
          </ul>
        </div>
        <div className="CheckoutOptionsBottomSheet_note">
          {t(
            "components.bottomSheets.components.checkoutOptionsBottomSheet.checkoutOptionsNote",
            "Only purchases through Google Play are secured by Google. Play features such as Play gift cards, Play Points, purchase controls, and subscription management are only available when you choose Google Play at checkout."
          )}
        </div>
        <div className="CheckoutOptionsBottomSheet_buttonContainer">
          <button
            className="CheckoutOptionsBottomSheet_buttonContainer_learnMoreBtn"
            onClick={() => handleLearnMoreClick()}
          >
            Learn more
          </button>
          <button
            className="CheckoutOptionsBottomSheet_buttonContainer_continueBtn"
            onClick={() => setIsPaymentOptionsScreenVisible(true)}
          >
            Continue
          </button>
        </div>
      </div>
    );
  };

  return (
    <Modal
      showModal={showCheckoutOptionsBottomSheet}
      handleClose={() => {
        // resetting the current selected payment methoda
        dispatch(actionCreator.setSelectedPaymentMethodAction(null));
        dispatch(actionCreator.showCheckoutOptionsBottomSheetAction(false));
      }}
      header={
        <div className="CheckoutOptionsBottomSheet_heading">
          {!isPaymentOptionsScreenVisible
            ? t(
                "components.bottomSheets.components.checkoutOptionsBottomSheet.heading1",
                "Changes to your checkout options"
              )
            : t(
                "components.bottomSheets.components.checkoutOptionsBottomSheet.heading2",
                "Choose how to check out"
              )}
        </div>
      }
    >
      {!isPaymentOptionsScreenVisible && renderCheckoutOptionsScreen()}
      {isPaymentOptionsScreenVisible && (
        <PaymentOptionsScreen handleLearnMoreClick={handleLearnMoreClick} />
      )}
    </Modal>
  );
};

export default CheckoutOptionsBottomSheet;
